import React, { Component, createRef } from 'react';
import { Input, List, Grid, Button, Dropdown, Icon, Popup } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import fuzzysort from 'fuzzysort';
import axios from 'axios';
import '../App.css';
import { API_URL, WEB_URL } from '../App.js';
import { YugtunLoader, WordItem, TagColors } from './SearchHelper.js';
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
import { sanitize } from 'dompurify';
// import {categories} from './constants/categories.js';
// import {categoriesUrlLookup} from './constants/categoriesUrlLookup.js';

// import { dialogueGenerator } from './constants/dialogueListGenerator.js';
//test

import * as Scroll from 'react-scroll';
// import { Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
// import ReactGA from "react-ga4";
// ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;
var categories = {}

const options1 = {
  keys: ['k','e','qaw','qik','utq','qig'],
  limit: 40, // don't return more results than you need!
  threshold: -50, // don't return bad results
  // threshold: -Infinity, // don't return bad results
};
const options2 = {
  keys: ['k','e'],
  limit: 40, // don't return more results than you need!
  threshold: -50, // don't return bad results
  // threshold: -Infinity, // don't return bad results
};


const sortOptions = [
  { key: 'id', text: 'ID (oldest)', value: 1 },
  { key: 'id', text: 'ID (newest)', value: 2 },
  { key: 'k', text: 'Kiŋikmiut (alphabetical)', value: 3 },
  { key: 'e', text: 'English (alphabetical)', value: 4 },
]

const showOptions = [
  { key: 'all', text: 'All Terms', value: 1 },
  { key: 'Kinship', text: 'Kinship Terms', value: 2 },
  { key: 'Color', text: 'Color Terms', value: 3 },
  { key: 'Direction', text: 'Direction Terms', value: 4 },
  { key: 'Body', text: 'Body Terms', value: 5 },
]

let englishShowOptions = {
  2:'Kinship',
  3:'Color',
  4:'Direction',
  5:'Body',
}


let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px',fontSize:'16px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px',fontSize:'16px'}
}

let innerWidthSetting = 700
let nonLinguistic = {
  'Kiŋikmiut':'Wales - Written in Richard Atuk Phonetic Script',
  'Qawiaraq':'Kawerak - Some entries referenced from Qawiaraq Igaluik Inupiat Dictionary',
  'Qikiqtaġruk':'Kotzebue - Some entries referenced from Inupiatun Dictionary, 2nd edition',
  'Utqiaġvik':"Formerly Barrow - Some entries referenced from Iñupiaq to English Dictionary",
  'Qigiqtaq':"Shishmaref",
}


class Home extends Component {
	constructor(props) {
		super(props);
    // console.log(props.location)
		this.state = {
			search: props.location.state === undefined ? '' :props.location.state.history[0],
			wordsList: props.location.state === undefined ? [] : props.location.state.history[1],
      sortOptionValue: props.location.state === undefined ? 1 : props.location.state.history[2],
      showOptionValue: props.location.state === undefined ? 1 : props.location.state.history[3],
      homeMode: 0,
      // props.location.state === undefined ? 0 : ('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? 3 : props.location.state.history[3]),
      // activeAudioIndex: props.location.state === undefined || 'currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? {} : props.location.state.history[4],
      // normalizedresults: props.location.state === undefined || props.location.state.history === undefined ? false : props.location.state.history[4],
      history: props.location.state === undefined ? [] : props.location.state.history,

      parseIndex:0,
      playingAudio: false,
      prevSearch: [],
      prevWordsList: [],
      logoup:false,

      currentCategory: props.location.state === undefined ? 'all' :('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? props.location.state.currentCategory:'all'),
      childrenCategories:[],
      parentCategories:[],

      categoriesDisplayed:[],
      // combinedAudio:[],

      useExample:true,
      useConversational:true,
      usePhrasebook:true,
      audioFilterChangeable:true,

      seeMoreAcknowledgments:false,
      siuSearchList:[...this.props.siuSearchList],
      sortedSiuSearchList:[...this.props.siuSearchList],
      width: window.innerWidth, 
      height: window.innerHeight,
      largeWindow: window.innerWidth >= innerWidthSetting,
      copyClicked:false,
      // sortOptionValue:1,
      // showOptionValue:1,
		}
    // console.log('new')
		this.handleRef = createRef()
		// this.handleRef2 = createRef()

    if (props.location.state !== undefined && 'history' in props.location.state) {
      // console.log('hi',props.location.state.history[2])
      scroll.scrollTo(props.location.state.history[4]);
    }
	}

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    // const categoriesDisplayed = [];
    // for (var key of Object.keys(categories)) {
    //   if (!key.includes(".")) {
    //     categoriesDisplayed.push(key)
    //   }   
    // }
    // const queryParameters = new URLSearchParams(window.location.search)
    // const category = queryParameters.get("category")
    // if (category !== null) {
    //   this.setState({activeTabIndex:3, homeMode:3, tabValue:3})
    //   if (category in categoriesUrlLookup) {
    //     this.setState({currentCategory:categoriesUrlLookup[category] })
    //     this.retrieveFamilyCategories(categoriesUrlLookup[category])
    //   } else {
    //     this.props.history.push('/?category=all')
    //   }      
    // }
    // this.setState({ categoriesDisplayed: categoriesDisplayed });

    if (this.state.sortOptionValue !== 1 || this.state.showOptionValue !== 1) {
      this.showSiuList();
      this.sortSiuList();
    }
    // console.log(this.props.audioSearchList)
    // console.log(this.props.audiolibrary)
    // this.setState({combinedAudio:[...this.props.audioSearchList,...this.props.audiolibrary]})
    // this.setState({combinedAudio:this.props.audiolibrary})
  }
  
  componentDidUpdate(prevProps, prevState) {

    // if (this.state.useExample !== prevState.useExample || this.state.useConversational !== prevState.useConversational || this.state.usePhrasebook !== prevState.usePhrasebook) {
    //   this.onChangeSearch(true, 2, null,this.state.search)
    // }

    if (this.state.largeWindow !== prevState.largeWindow) {
      this.setState({search:'',wordsList:[]})
    }
    // if (this.state.sortOptionValue !== 1 || this.state.showOptionValue !== 1) {
    //   this.showSiuList()
    // }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    window.removeEventListener('scroll', this.listenToScroll)
  }

  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop

    this.setState({
      Yposition: winScroll,
    })
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight, largeWindow: window.innerWidth >= innerWidthSetting });
  };

  setHistory = (num) => {
    this.setState({
      prevSearch:num[0],
      prevWordsList:num[1],
    })
  }

  // resetAll = (e,data) => {
  // 	this.setState({
  // 		search:"",
  //     // newSearchList:[],
  //     searchWord:"",
  // 	})
  // }



	// 	returnTitle = (word) => {
	// 		let newword = word.split(' | ');
	// 		let fulllist = [];
	// 		for (let i = 0; i < newword.length; i++) {
	// 			if (newword[i].includes('(‐)')) {
	// 				fulllist.push(newword[i].split('(‐)')[0])
	// 				fulllist.push(newword[i].split('(‐)')[0]+'‐')
	// 			} else {
	// 				fulllist.push(newword[i])
	// 			}
	// 		}
	// 		return fulllist
	// 	}

	// 	returnDefinition = (word) => {
	// 		let newword = word.split(' | ')
	// 		return newword
	// 	}
    // tlingitNormalize = (tlingit) => {
    //   tlingit = tlingit.replaceAll('Á','Á').replaceAll('Á','Á')
    //   tlingit = tlingit.replaceAll('É','É').replaceAll('É','É')
    //   tlingit = tlingit.replaceAll('Í','Í').replaceAll('Í','Í')
    //   tlingit = tlingit.replaceAll('Ó','Ó').replaceAll('Ó','Ó')
    //   tlingit = tlingit.replaceAll('Ú','Ú').replaceAll('Ú','Ú')
    //   tlingit = tlingit.replaceAll('á','á').replaceAll('á','á')
    //   tlingit = tlingit.replaceAll('é','é').replaceAll('é','é')
    //   tlingit = tlingit.replaceAll('í','í').replaceAll('í','í')
    //   tlingit = tlingit.replaceAll('ó','ó').replaceAll('ó','ó')
    //   tlingit = tlingit.replaceAll('ú','ú').replaceAll('ú','ú')
    //   tlingit = tlingit.replaceAll('ʼ',"'")
    //   tlingit = tlingit.replaceAll('̱','̲')
    //   tlingit = tlingit.replaceAll('Ḵ','K̲')
    //   tlingit = tlingit.replaceAll('ḵ','k̲')
    //   return tlingit
    // }

    // returnCorrectAudioLibrary = () => {
    //     if (this.state.useExample && this.state.useConversational && this.state.usePhrasebook) {
    //       return this.props.audiolibrary
    //     } else if (this.state.useExample && this.state.useConversational ) {
    //       return this.props.oneandtwo
    //     } else if (this.state.useConversational && this.state.usePhrasebook ) {
    //       return this.props.twoandthree
    //     } else if (this.state.useExample && this.state.usePhrasebook ) {
    //       return this.props.oneandthree
    //     } else if (this.state.useExample) {
    //       return this.props.examplesentenceaudio1
    //     } else if (this.state.useConversational) {
    //       return this.props.conversational2
    //     } else if (this.state.usePhrasebook) {
    //       return this.props.phrasebookaudio3
    //     } else { // edge case
    //       return this.props.audiolibrary
    //     }
    // }

  	onChangeSearch = (bool,homeMode,event,data) => {
      let word
      let searchoptions = options1
      // if (window.innerWidth < 480) {
        // searchoptions = options2
      // }
      let siuSearchListToUse = []
      if (this.state.showOptionValue != 1) {
        siuSearchListToUse = this.state.sortedSiuSearchList
      } else {
        siuSearchListToUse = this.state.siuSearchList
      }
      if (bool) {
        word = data
      } else {
        word = data.value
        homeMode = this.state.homeMode
      }
      // this.setState({'normalizedresults':false})
	    let new_search
      let new_search_normal
      let wordsList
      // word = this.tlingitNormalize(word)
      new_search = word.replaceAll('s/he','').replaceAll('O-S-ø-','').replaceAll('S-ø-','').replaceAll(' (Ø act)','').replaceAll(' (Ø state)','').replaceAll('x̱','x̲')
      new_search_normal = word.replaceAll('s/he','').replaceAll('O-S-ø-','').replaceAll('S-ø-','').replaceAll(' (Ø act)','').replaceAll(' (Ø state)','').replaceAll('x̱','x̲').replaceAll("x̲","x").replaceAll("x̲'","x").replaceAll("x'","x").replaceAll("k̲","k").replaceAll("k̲'","k").replaceAll("k'","k").replaceAll("g̲","g")

	    if (false && homeMode === 0) {
        wordsList = fuzzysort.go(new_search, siuSearchListToUse, searchoptions) 
      } else {
        wordsList = fuzzysort.go(new_search, siuSearchListToUse, searchoptions)         
      }

	    this.setState({ wordsList: wordsList, search: word,  activeAudioIndex: {} },()=>{this.setState({audioFilterChangeable:true})});
  	}

  	processStyledText = (sentence) => {
      if (sentence != undefined ) {
        sentence = sentence.replaceAll("???","...")
        sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("«",'"').replaceAll("»",'"')
      }
      return <span>{sentence}</span>

      // let matches = sentence.match(/⎡.*?⎤/g)
      // let matches1 = sentence.match(/{.*?}/g)
      // let matches2 = sentence.match(/_.*?_/g)
      // // console.log(matches2)
      // if (matches !== null || matches1 !== null || matches2 !== null) {
      //   if (matches !== null) {
      //     matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
      //   }
      //   if (matches1 !== null) {
      //     matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
      //   }
      //   if (matches2 !== null) {
      //     matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
      //   }
      //   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
      // } else {
      //   return <span>{sentence}</span>
      // }


  	}


    processStyledTextLink = (sentence) => {
      sentence = sentence.replaceAll(">","")


      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("↞","").replaceAll("&","").replaceAll("↠","")
      let matches = sentence.match(/⎡.*?⎤/g)
      let matches1 = sentence.match(/{.*?}/g)
      let matches2 = sentence.match(/_.*?_/g)
      // console.log(matches2)
      if (matches !== null || matches1 !== null || matches2 !== null) {
        if (matches !== null) {
          matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
        }
        if (matches1 !== null) {
          matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
        }
        if (matches2 !== null) {
          matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
        }
        return <span style={{whiteSpace:'nowrap'}} dangerouslySetInnerHTML={{__html: sentence}} />    
      } else {
        return <span style={{whiteSpace:'nowrap'}}>{sentence}</span>
      }


    }

  	// processUsageDefinition = (definition, tag, ind) => {
  	// 	// console.log(definition)
		// 	let matches = definition.match(/<.*?>/g)

		// 	if (matches !== null) {
		// 		matches.map((m) => definition = definition.replaceAll(m,"<i>"+m.slice(1,-1)+'</i>'))				
		// 	}
		// 	let matches1 = definition.match(/⎡.*?⎤/g)
		// 	if (matches1 !== null) {
		// 		matches1.map((m) => definition = definition.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))				
		// 	}

    //   let matches2 = definition.match(/_.*?_/g)
    //   if (matches2 !== null) {
    //     matches2.map((m) => definition = definition.replaceAll(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
    //   }

    //   let matches3 = definition.match(/{.*?}/g)
    //   if (matches3 !== null) {
    //     matches3.map((m) => definition = definition.replaceAll(m,m.slice(1,-1)))            
    //   }

		// 	if (tag !== 'noun') {
		// 		definition = '<i>s/he/it is </i>'+definition
		// 	}

		// 	definition = definition.replaceAll("⟨","").replaceAll("⟩","")

  	// 	return <span dangerouslySetInnerHTML={{__html: definition}} />
  	// }		


  	// processAudioDefinition = (sentence) => {			
    //   // console.log(sentence)
		// 	let matches = sentence.match(/⎡.*?⎤/g)
		// 	if (matches !== null) {
		// 		matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))				
		// 	}
		// 	sentence = sentence.replaceAll('>','')
		// 	// console.log(sentence)
		// 	// var dom = document.createElement('span');
		// 	// dom.innerHTML = sentence;
  	// 	return <span dangerouslySetInnerHTML={{__html: sentence}} />
  	// }


  repeatAudio(id, inu, event, data) {
    // console.log(audio, event, data)

    if (!this.state.playingAudio) {
      let sound = new Audio(API_URL + "kingikaudiolibrary?inu=" + inu + "&speakerID=" + id);
      this.setState({playingAudio: true});

      sound.play()

      sound.onended=()=>{
        this.setState({playingAudio: false});
      }
    }
  }


  // onKeyPress(event, data) {

  //   // console.log(event, data, this.state)
    
  //   if (event.key === 'Enter' && this.state.wordsList.length > 0) {
  //     let audio = this.state.wordsList[0].obj.mp3
  //     let sound = new Audio(API_URL + "/tlingitaudiolibrary/" + audio);
  //     this.setState({playingAudio: true});

  //     sound.play()

  //     sound.onended=()=>{
  //       this.setState({playingAudio: false});
  //     }
  //   }
  // }

  // soundDone = () => {
  //   console.log('done!')
  // }

  // setActiveAudioIndex = (word, index) => {
  //   // console.log(word, index)
  //   let activeAudioIndex = this.state.activeAudioIndex
  //   if (index in activeAudioIndex) {
  //     delete activeAudioIndex[index]
  //     this.setState({activeAudioIndex:activeAudioIndex})
  //   } else {
  //     // activeAudioIndex[index] = ""
  //     // this.setState({activeAudioIndex:activeAudioIndex})
  //     // console.log(word)

  //     axios
  //       .get(API_URL + "/tlingitaudiolibraryword/" + word.obj.key)
  //       .then(response => {
  //         // let end = now();
  //         // ReactGA.timing({
  //         //   category: 'Loading',
  //         //   variable: 'dictionary',
  //         //   value: (end-start).toFixed(3),
  //         //   label: 'Dictionary loading'
  //         // });
  //         // audiolibrary = response.data;
  //         // fuse.setCollection(dictionary);
  //         // fuse1.setCollection(dictionary);
  //         activeAudioIndex[index] = response.data
  //         this.setState({activeAudioIndex:activeAudioIndex})
  //         // console.log(response.data);
  //         // activeAudioIndex[index] = response.data
  //         // this.setState({activeAudioIndex:activeAudioIndex})

  //         // dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
  //         // dictionary_prepared = fuzzysort.prepare(dictionary)

  //         // this.setState({ audiolibrary: audiolibrary });
  //       });


  //   }
  //   // console.log(activeAudioIndex)
  //   // this.setState({activeAudioIndex:activeAudioIndex})
  // }



  // handleTabChange = (e,data) => {
  //   // console.log(data.activeIndex, this.state.activeIndex)
  //   if (data.activeIndex == this.state.activeTabIndex) {
  //     this.resetAll()
  //   }

  //   if (data.activeIndex === 0 && this.state.activeTabIndex !== 0) {
  //     this.setState({wordsList: [], homeMode: data.activeIndex, activeTabIndex:0})
  //     this.onChangeSearch(true, 0, null,this.state.search)
  //     this.props.history.push('/')
  //   } else if (data.activeIndex === 1 && this.state.activeTabIndex !== 1) {
  //     // if (!this.state.yugtunAnalyzer) {
  //     this.setState({wordsList: [], homeMode: data.activeIndex, activeTabIndex:1});                     
  //     this.onChangeSearch(true, 1, null,this.state.search)
  //     this.props.history.push('/')
  //     // this.inputClicked()
  //     // }
  //   } else if (data.activeIndex === 2 && this.state.activeTabIndex !== 2) {
  //     // if (!this.state.yugtunAnalyzer) {
  //     this.setState({wordsList: [], homeMode: data.activeIndex, activeTabIndex:2});                     
  //     this.onChangeSearch(true, 2, null,this.state.search)
  //     this.props.history.push('/')
  //     // this.inputClicked()
  //     // }
  //   }else if (data.activeIndex === 3 && this.state.activeTabIndex !== 3) {
  //     // if (!this.state.yugtunAnalyzer) {
  //     this.setState({wordsList: [], homeMode: data.activeIndex, activeTabIndex:3});   
  //     this.props.history.push('/?category=all')                  
  //     // this.onChangeSearch(true, 3, null,this.state.search)
  //     // this.inputClicked()
  //     // }
  //   }
  // }



  // handleTabChange2 = (e, {value}) => {

  //   if (value == this.state.tabValue) {
  //     this.resetAll()
  //   }

  //   if (value === 0 && this.state.tabValue !== 0) {
  //     this.setState({wordsList: [], homeMode: value, activeTabIndex:0})
  //     this.onChangeSearch(true, 0, null,this.state.search)
  //     this.props.history.push('/')
  //   } else if (value === 1 && this.state.tabValue !== 1) {
  //     this.setState({wordsList: [], homeMode: value, activeTabIndex:1});                     
  //     this.onChangeSearch(true, 1, null,this.state.search)
  //     this.props.history.push('/')
  //   } else if (value === 2 && this.state.tabValue !== 2) {
  //     this.setState({wordsList: [], homeMode: value, activeTabIndex:2});                     
  //     this.onChangeSearch(true, 2, null,this.state.search)
  //     this.props.history.push('/')
  //   } else if (value === 3 && this.state.tabValue !== 3) {
  //     this.setState({wordsList: [], homeMode: value, activeTabIndex:3});     
  //     this.props.history.push('/?category=all')                
  //     // this.onChangeSearch(true, 3, null,this.state.search)
  //   }
  // 	this.setState({tabValue: value})
  // }

  // randomizeSentence = (direction) => {
  //   if (direction === '+') {
  //     if (this.state.randomSentences.length-1 === this.state.randomSentenceIndex) {
  //       this.setState({randomSentenceIndex: 0})        
  //     } else {
  //       this.setState({randomSentenceIndex: this.state.randomSentenceIndex+1})        
  //     }
  //   } else {
  //     this.setState({randomSentenceIndex: this.state.randomSentenceIndex-1})
  //   }
  // }

  // newUsageBaseDisplay = (word) => {
  //   // console.log(word)

  //   let returnNewUsageBaseDisplayLabel = {
  //     'verb phrase':[
  //       'present',
  //       'past',
  //       'question',
  //       'polite command',
  //       'command',
  //     ],
  //     'noun':[
  //       'stem',
  //       'possessive',
  //       'locative noun case',
  //       'with pronoun',
  //     ],
  //   }
  //   return  <List.Item>
  //             <List.Content style={{fontSize:'16px',paddingTop:'8px',paddingBottom:'10px'}}><span style={{paddingRight:'20px',fontWeight:'500'}}>{word.url.replaceAll(',',', ')}</span><span style={{paddingRight:'15px',fontStyle:'italic'}}>{this.processStyledText(word.thisDefinition)}</span><span style={{'marginLeft':'15px',marginRight:'6px',cursor:'pointer'}}><TagColors tags={word.t} width={window.innerWidth} /></span></List.Content>
  //             {word.newUsageDefinitions.map((u,uindex)=>
  //             <List.Content style={{paddingLeft:'20px'}}>
  //               <Link to={{pathname: '/wordbuilder/' + word.url, state: {initBackendCall:word.backendCalls[uindex], usagedictionary_dict: this.props.usagedictionary_dict, activeKeyInEditIndex:0, value1: 's31-1(1)',value2: 'o31-3(2)', nounvalue1: '1', nounvalue2: '00(3)', fullDefinition: word.fullDefinition, num: word.num, usageDefinition: word.usageDefinition, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  //                 <List.Content floated='right'>
  //                   <Icon circular style={{marginTop:'3px', color:'#8f8f8f'}} size='small' name='chevron right' />
  //                 </List.Content>
  //               </Link>
  //               <List.Content style={{display:'flex',fontSize:'16px',paddingBottom:'8px',fontFamily:customFontFam,lineHeight:'25px'}}>
  //                 <span style={{flex:2,'paddingRight':'3px',fontWeight:'500'}}>
  //                 <Link style={{borderBottom:'1px solid #858585',paddingBottom:'1px',color:'#306190'}} to={{pathname: '/wordbuilder/' + word.url, state: {initBackendCall:word.backendCalls[uindex], activeKeyInEditIndex:0, value1: 's31-1(1)',value2: 'o31-3(2)', nounvalue1: '1', nounvalue2: '00(3)', fullDefinition: word.fullDefinition, num: word.num, usageDefinition: word.usageDefinition, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  //                 {this.processStyledTextLink(word.usageWords[uindex])}
  //                 </Link>
  //                 </span>
  //                 <span style={{flex:5,fontSize:'16px',color:'#000000cc',fontWeight:'400',lineHeight:'23px',paddingTop:'4px'}}>{word.newUsageDefinitions[uindex]}</span>
  //                 <span style={{flex:3,color:'#BEBEBE',fontStyle:'italic',textAlign:'right'}}>{returnNewUsageBaseDisplayLabel[word.t][uindex]}</span>
  //               </List.Content>
  //             </List.Content>
  //             )}
  //           </List.Item>

  //   // return <List.Item>
  //   // <Link to={{pathname: '/wordbuilder/' + word.url, state: {initBackendCall:word.backendCalls[0], activeKeyInEditIndex:0, value1: 's31-1(1)',value2: 'o31-3(2)', nounvalue1: '1', nounvalue2: '00(3)', fullDefinition: word.fullDefinition, word: word.usageWord, num: word.num, usageDefinition: word.usageDefinition, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  //   //   <List.Content floated='right'>
  //   //     <Icon circular style={{marginTop:'8px', color:'#8f8f8f'}} size='large' name='chevron right' />
  //   //   </List.Content>
  //   // </Link>
  //   //   <List.Content>
  //   //     <List.Header style={{fontSize:'16px',paddingBottom:'4px',fontFamily:customFontFam,lineHeight:'25px'}}>
  //   //       <div> 
  //   //       <span style={{'paddingRight':'3px',fontWeight:'500'}}>
  //   //       <Link style={{borderBottom:'1px solid #858585',paddingBottom:'1px',color:'#306190'}} to={{pathname: '/wordbuilder/' + word.url, state: {initBackendCall:word.backendCalls[0], activeKeyInEditIndex:0, value1: 's31-1(1)',value2: 'o31-3(2)', nounvalue1: '1', nounvalue2: '00(3)', fullDefinition: word.fullDefinition, word: word.usageWord, num: word.num, usageDefinition: word.usageDefinition, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  //   //       {this.processStyledText(word.usageWord)}
  //   //       </Link>
  //   //       </span>
  //   //       <span style={{'marginLeft':'15px',marginRight:'6px',cursor:'pointer'}}>  
  //   //         <TagColors tags={word.t} width={window.innerWidth} />
  //   //       </span>
  //   //       </div>
  //   //     </List.Header>
  //   //     <List.Description style={{fontSize:'16px',color:'#000000cc',fontWeight:'400',lineHeight:'23px',paddingTop:'4px'}}>{this.processUsageDefinition(word.usageDefinition,word.t,i)}</List.Description>
  //   //   </List.Content>
  //   // </List.Item>
  // }

  // spanParses = (spanList,fontSize,fontWeight) => {
  //   return spanList.map((t,tindex)=>{
  //     let entries = [...t[1],...t[2]]
  //     let maxLength = (entries.length % 2 == 0 ? entries.length/2 : (entries.length+1)/2)

  //     if (entries.length == 0) {

  //       return <span style={{marginBottom:'2px',marginTop:'2px',paddingBottom:'1px',marginRight:'6px',fontSize:fontSize, fontWeight:fontWeight, borderBottom:'2px dotted white'}}>
  //         {this.processStyledText(t[0])}
  //       </span>

  //     } else {

  //       return <Popup hideOnScroll on='click' position='bottom center' onClose={()=>{this.setState({parseIndex:0})}} content={
  //         <div style={{fontFamily:customFontFam, fontSize:'16px'}}>
  //           <div style={{textAlign:'center',fontStyle:'italic',color:'#aeaeae',margin:3}}>Possible Entries</div>
  //           {entries.map((k,kindex)=>{
  //             if (kindex == this.state.parseIndex*2 || kindex == this.state.parseIndex*2+1) {
  //             return <div style={{marginTop:15,marginBottom:10}}>
  //                 <div style={{display:'flex',alignItems:'center',flexDirection:'row',fontWeight:'500'}}>
  //                       {k['url'].length === 0 ?
  //                         <span style={{whiteSpace:'nowrap'}}>{k['tlingit']}</span>
  //                         :
  //                         <a style={{whiteSpace:'nowrap'}} href={"https://www.haashuka.com/"+k['url']} target="_blank">{k['tlingit']}</a>
  //                       }
  //                       {k['tags'].map((t,tindex)=>
  //                           (tindex === 0 && t.length != 0 ?
  //                       <span style={{display:'flex',marginLeft:'12px'}}>
  //                         <TagColors homeMode={0} tags={t} width={window.innerWidth} />
  //                       </span>
  //                       :
  //                       null
  //                       )
  //                     )}
  //                 </div>
  //                 <div style={{fontStyle:'italic',marginTop:'5px'}}>{k['english']}</div>
  //             </div>
  //             }})}

  //           {this.state.parseIndex+1 < maxLength+1 && maxLength > 1 ?
  //             <div style={{display:'flex',justifyContent:'center',marginTop:'12px'}}>
  //             <Icon disabled={this.state.parseIndex === 0} circular onClick={() => this.setState({parseIndex: this.state.parseIndex-1})} style={{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'15px'}}  name='chevron left' />
  //             <Label basic circular style={{width:30,color:'#aeaeae',fontWeight:500,height:30,fontSize:14,}}>
  //               {this.state.parseIndex + 1}
  //             </Label>
  //             <Icon disabled={this.state.parseIndex+1 == maxLength} circular onClick={() => this.setState({parseIndex: this.state.parseIndex+1})} style={{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'15px'}}  name='chevron right' />
  //             </div>  
  //             :
  //             null
  //           }      
  //         </div>
  //       } trigger={
  //         <span style={{cursor:'pointer', marginBottom:'2px',marginTop:'2px',paddingBottom:'1px',marginRight:'6px',fontSize:fontSize, fontWeight:fontWeight, borderBottom:'2px dotted #b5b5b5'}}>
  //           {this.processStyledText(t[0])}
  //         </span>
  //       } />

  //     }
  //   })
  // }



  // underlineFixer = (word) => {
  //   // console.log(word)
  //   word = word.replaceAll('g</b>̲','g̲</b>').replaceAll('G</b>̲','G̲</b>').replaceAll('x</b>̲','x̲</b>').replaceAll('X</b>̲','X̲</b>').replaceAll('k</b>̲','k̲</b>').replaceAll('K</b>̲','K̲</b>')
  //   word = word.replaceAll('g<b>̲</b>','g̲<b></b>').replaceAll('G<b>̲</b>','G̲<b></b>').replaceAll('x<b>̲</b>','x̲<b></b>').replaceAll('X<b>̲</b>','X̲<b></b>').replaceAll('k<b>̲</b>','k̲<b></b>').replaceAll('K<b>̲</b>','K̲<b></b>')
  //   word = word.replaceAll('g<b>̲','g̲<b>').replaceAll('G<b>̲','G̲<b>').replaceAll('x<b>̲','x̲<b>').replaceAll('X<b>̲','X̲<b>').replaceAll('k<b>̲','k̲<b>').replaceAll('K<b>̲','K̲<b>')
  //   word = word.replaceAll('a</b>́','á</b>').replaceAll('e</b>́','é</b>').replaceAll('i</b>́','í</b>').replaceAll('o</b>́','ó</b>').replaceAll('u</b>́','ú</b>')
  //   word = word.replaceAll('a<b>́</b>','á<b></b>').replaceAll('e<b>́</b>','é<b></b>').replaceAll('i<b>́</b>','í<b></b>').replaceAll('o<b>́</b>','ó<b></b>').replaceAll('u<b>́</b>','ú<b></b>')
  //   word = word.replaceAll('a<b>́','á<b>').replaceAll('e<b>́','é<b>').replaceAll('i<b>́','í<b>').replaceAll('o<b>́','ó<b>').replaceAll('u<b>́','ú<b>')
  //   word = word.replaceAll('A</b>́','Á</b>').replaceAll('E</b>́','É</b>').replaceAll('I</b>́','Í</b>').replaceAll('O</b>́','Ó</b>').replaceAll('U</b>́','Ú</b>')
  //   word = word.replaceAll('A<b>́</b>','Á<b></b>').replaceAll('E<b>́</b>','É<b></b>').replaceAll('I<b>́</b>','Í<b></b>').replaceAll('O<b>́</b>','Ó<b></b>').replaceAll('U<b>́</b>','Ú<b></b>')
  //   word = word.replaceAll('A<b>́','Á<b>').replaceAll('E<b>́','É<b>').replaceAll('I<b>́','Í<b>').replaceAll('O<b>́','Ó<b>').replaceAll('U<b>́','Ú<b>')
  //   return word
  // }
  buttonGroupKeyboard = (homeMode) => {
    return  <Button.Group basic>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ā')}} style={letterbutton}>ā</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ō')}} style={letterbutton}>ō</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ġ')}} style={letterbutton}>ġ</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ł')}} style={letterbutton}>ł</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ł̣')}} style={letterbutton}>ł̣</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ḷ')}} style={letterbutton}>ḷ</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'ŋ')}} style={letterbutton}>ŋ</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'p̄')}} style={letterbutton}>p̄</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'q̄')}} style={letterbutton}>q̄</Button>
              <Button onClick={()=>{this.handleRef.current.focus(); this.onChangeSearch(true,homeMode,null,this.state.search+'t̄')}} style={letterbutton}>t̄</Button>
            </Button.Group>
  }

//   retrieveFamilyCategories(j) {
//   // console.log(categories[j])
//   // const children = [];
//   let parent = [];
//   // for (let i = 1; i < categories[j].children + 1; i++) {
//   //   children.push(j+'.'+i.toString())
//   // }
//   let wordsList = []

//   if (this.state.homeMode === 3 && Object.keys(this.props.urlDictionary).length > 0) {
//     categories[j].links.map((k)=>{
//       // console.log(k)
//       // console.log(Object.keys(this.props.urlDictionary).length)
//       wordsList.push({'obj':{'dialect':this.props.urlDictionary[k].dialect,'soundfile':this.props.urlDictionary[k].soundfile,'url':this.props.urlDictionary[k].url, 'pos':this.props.urlDictionary[k].pos, 'lexicon':this.props.urlDictionary[k].lexicon, 'gloss':this.props.urlDictionary[k].gloss}})
//     })
    
//     this.props.history.push('/?category='+categories[j].url)
//     // console.log(j)
//     // if (j.includes('.')) {
//     //   var p = j.split('.');
//     //   for (let k = 1; k < p.length; k++) {
//     //     parents.push((p.slice(0,k)).join('.'))
//     //   }
//     // }

//     if ('parent' in categories[j]) {
//       parent = categories[j].parent
//     }

//     this.setState({ 
//       currentCategory: j,
//       childrenCategories: categories[j].children,
//       parentCategories: parent,
//       // parentCategories: parents,
//       wordsList:wordsList,
//       });    
//   }

// }


  returnNonLinguisticTerm = (term, bottom) => {
    // console.log(term)
    // bottom = 'bottom'
    if (term in nonLinguistic) {
      return <div style={{fontSize:'16px',color:(this.state.width < innerWidthSetting ? '#808080' : '#777777'),fontStyle:'italic'}}>
                <Popup hideOnScroll on='click' position={bottom == 'bottom' ? 'bottom':'bottom right'} content={
                  <div style={{fontFamily:customFontFam,}}>
                    {nonLinguistic[term]}
                  </div>
                } trigger={
                  <span style={{cursor:'pointer',paddingBottom:'3px', borderBottom:'2px dotted #d5d5d5'}}>
                    {term.replaceAll('_',' ')}
                  </span>
                } />
            </div>      
    } else {
    return  <div style={{fontSize:'16px',color:(this.state.width < innerWidthSetting ? '#808080' : '#777777'),fontStyle:'italic'}}>
              {this.processStyledText(term.replaceAll('_',' '))}
            </div>      
          }
  }

  sortSiuList = (e, data) => {
    // console.log(e,data)
    let newSiuSearchList = [...this.props.siuSearchList]
    let colorList = ['1','2','3']
    let sortOptionValue = 1
    if (data == undefined) {
      sortOptionValue = this.state.sortOptionValue
    } else {
      sortOptionValue = data.value
    }
    if (sortOptionValue == 1) { // ID ascending
      newSiuSearchList.sort((a, b) => a.id - b.id)
      this.setState({sortOptionValue:1,siuSearchList:newSiuSearchList},()=>{this.showSiuList();})
    } else if (sortOptionValue == 2) { // ID descending
      newSiuSearchList.sort((a, b) => b.id - a.id)
      this.setState({sortOptionValue:2,siuSearchList:newSiuSearchList},()=>{this.showSiuList();})
    } else if (sortOptionValue == 3) { //kingikmiut
      newSiuSearchList.sort((a, b) => a.k.replaceAll('ā','azz').replaceAll('p̄','pzz').replaceAll('q̄','qzz').replaceAll('t̄','tzz').replaceAll('ō','ozz').localeCompare(b.k.replaceAll('ā','azz').replaceAll('p̄','pzz').replaceAll('q̄','qzz').replaceAll('t̄','tzz').replaceAll('ō','ozz')))
      this.setState({sortOptionValue:3,siuSearchList:newSiuSearchList},()=>{this.showSiuList();})
    } else if (sortOptionValue == 4) { //english
      newSiuSearchList.sort((a, b) => a.e.localeCompare(b.e))
      this.setState({sortOptionValue:4,siuSearchList:newSiuSearchList},()=>{this.showSiuList();})
    }
  }

  returnListItem = (word, bestHitIndex) => {
    let wordmatch = []
    if (bestHitIndex != -1) {
      wordmatch = word
      word = word.obj
    }
    return <List.Item style={{padding:'5px 1px'}} key={word.id}>

                  <Grid>
                    <Grid.Row style={{display:'flex',alignItems:'center',}} columns={this.state.largeWindow ? 8:4}>
                      <Grid.Column width={this.state.largeWindow ? 1:2}>
                          <List.Description style={{fontSize:'16px',color:'#a4a4a4',fontWeight:'200',lineHeight:'23px'}}>
                            {this.processStyledText(word.id)}                          
                          </List.Description>
                      </Grid.Column>
                      <Grid.Column width={this.state.largeWindow ? 3:6}>
                        <List.Content>
                          <List.Header style={{fontSize:'16px',fontFamily:customFontFam,lineHeight:'25px'}}>
                            <div style={{display:'flex',alignItems:'center'}}> 
                              <Link style={{color:'#306190'}} to={{pathname: '/search/' + word.id, state: { word: word.id, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.sortOptionValue, this.state.showOptionValue, this.state.Yposition] }}}>
                              <span style={{'paddingRight':'3px',fontWeight:'500'}}> {/* ,borderBottom:'1px solid #858585',paddingBottom:'1px', */}
                              {bestHitIndex == 0 && wordmatch[0] != null && 'indexes' in wordmatch[0] ?
                                wordmatch[0].highlight((m, i) => <react key={i} style={{fontWeight:'bold'}}>{m}</react>)
                                :
                                this.processStyledTextLink(word.k+(false && word.type == 'v' ? '~' : ''))
                              }
                              </span>
                              </Link>

                              {'soundfile' in word ?
                                <Icon circular onClick={()=>this.repeatAudio(word.obj.soundfile)} style={{marginLeft:'10px',fontSize:'13px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
                                :
                                ('k' in word['audio'] ?
                                  Object.keys(word['audio']['k']).map((id)=>{
                                    return <Icon circular onClick={()=>this.repeatAudio(word['audio']['k'][id],word.k)} style={{marginLeft:'10px',fontSize:'13px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
                                  })                                  
                                  :
                                  null
                                )
                              }

                            </div>
                          </List.Header>
                        </List.Content>
                      </Grid.Column>
                      <Grid.Column width={this.state.largeWindow ? 3:6}>
                          <List.Description style={{fontSize:'16px',color:'#000000',fontWeight:'400',lineHeight:'23px'}}>
                          {bestHitIndex == 1 && wordmatch[1] != null && 'indexes' in wordmatch[1]  ?
                            wordmatch[1].highlight((m, i) => <react key={i} style={{fontWeight:'bold'}}>{m}</react>)
                            :
                            this.processStyledText(word.e)
                          }
                          </List.Description>
                      </Grid.Column>
                      {this.state.largeWindow ? 
                      <Grid.Column width={2}>
                          <List.Description style={{fontSize:'16px',color:'#323232',fontWeight:'400',lineHeight:'23px'}}>
                            {bestHitIndex == 2 && wordmatch[2] != null && 'indexes' in wordmatch[2]  ?
                              wordmatch[2].highlight((m, i) => <react key={i} style={{fontWeight:'bold'}}>{m}</react>)
                              :
                              this.processStyledText(word.qaw)
                            }
                          </List.Description>                        
                      </Grid.Column>
                        :
                        null
                      }
                      {this.state.largeWindow ? 
                      <Grid.Column style={{wordWrap:(word.utq.length !== 0 ? 'break-word':''),paddingRight:0}} width={2}>
                          <List.Description style={{fontSize:'16px',color:'#323232',fontWeight:'400',lineHeight:'23px'}}>
                            {bestHitIndex == 3 && wordmatch[3] != null && 'indexes' in wordmatch[3]  ?
                              wordmatch[3].highlight((m, i) => <react key={i} style={{fontWeight:'bold'}}>{m}</react>)
                              :
                              this.processStyledText(word.qik)
                            }
                          </List.Description>    
                      </Grid.Column>
                        :
                        null
                      }
                      {this.state.largeWindow ? 
                      <Grid.Column width={2}>
                          <List.Description style={{fontSize:'16px',color:'#323232',fontWeight:'400',lineHeight:'23px'}}>
                            {bestHitIndex == 4 && wordmatch[4] != null && 'indexes' in wordmatch[4]  ?
                              wordmatch[4].highlight((m, i) => <react key={i} style={{fontWeight:'bold'}}>{m}</react>)
                              :
                              this.processStyledText(word.utq)
                            }
                          </List.Description>    
                      </Grid.Column>
                        :
                        null
                      }
                      {this.state.largeWindow ? 
                      <Grid.Column width={2}>
                          <List.Description style={{fontSize:'16px',color:'#323232',fontWeight:'400',lineHeight:'23px'}}>
                            {bestHitIndex == 5 && wordmatch[5] != null && 'indexes' in wordmatch[5]  ?
                              wordmatch[5].highlight((m, i) => <react key={i} style={{fontWeight:'bold'}}>{m}</react>)
                              :
                              this.processStyledText(word.qig)
                            }
                          </List.Description>  
                      </Grid.Column>
                        :
                        null
                      }
                      <Grid.Column width={this.state.largeWindow ? 1:2}>
                          <Link to={{pathname: '/search/' + word.id, state: { word: word.id, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.sortOptionValue, this.state.showOptionValue, this.state.Yposition] }}}>
                            <List.Content floated='right'>
                              <Icon circular style={{color:'#8f8f8f'}} name='chevron right' />
                            </List.Content>
                          </Link>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>

                </List.Item>
  }

  showSiuList = (e, data) => {
    console.log(e,data,this.state)
    let newSiuSearchList = this.state.siuSearchList
    // let colorList = ['1','2','3']
    let showOptionValue = 1
    if (data == undefined) {
      showOptionValue = this.state.showOptionValue
    } else {
      showOptionValue = data.value
    }

    if (showOptionValue == 1) { //all
      this.setState({showOptionValue:1,siuSearchList:this.state.siuSearchList},()=>{this.onChangeSearch(true,0,null,this.state.search)})
    } else {
      Object.keys(englishShowOptions).map((k)=>{
        if (showOptionValue == k) {
          newSiuSearchList = newSiuSearchList.filter(a => a.categories.includes(englishShowOptions[k]))
          this.setState({showOptionValue:parseInt(k),sortedSiuSearchList:newSiuSearchList},()=>{this.onChangeSearch(true,0,null,this.state.search)})
        }
      })
    }
    // if (showOptionValue == 2) { //Kinship
    //   newSiuSearchList = newSiuSearchList.filter(a => a.categories.includes('Kinship')) //FILTER FUNCTION
    //   this.setState({showOptionValue:2,sortedSiuSearchList:newSiuSearchList})
    // } else if (showOptionValue == 3) { //Color
    //   newSiuSearchList = newSiuSearchList.filter(a => a.categories.includes('Color')) //FILTER FUNCTION
    //   this.setState({showOptionValue:3,sortedSiuSearchList:newSiuSearchList})
    // } else if (showOptionValue == 4) { //Direction
    //   newSiuSearchList = newSiuSearchList.filter(a => a.categories.includes('Direction')) //FILTER FUNCTION
    //   this.setState({showOptionValue:4,sortedSiuSearchList:newSiuSearchList})
    // } else if (showOptionValue == 5) { //Body
    //   newSiuSearchList = newSiuSearchList.filter(a => a.categories.includes('Body')) //FILTER FUNCTION
    //   this.setState({showOptionValue:5,sortedSiuSearchList:newSiuSearchList})
    // }
    // if (this.state.search.length > 0) {
    //   this.onChangeSearch(true,0,null,this.state.search)
    // }
  }


	render() {
    // console.log(this.state)
    // console.log(this.props)
		let isCommon = false
    let displayList = (this.state.search.length >= 1 && this.state.wordsList.length > 0) || (this.state.homeMode === 3 && this.state.wordsList.length > 0);
    let wordsList = this.state.wordsList;
    if (wordsList.length == 0) {
      if (this.state.showOptionValue != 1) {
        wordsList = this.state.sortedSiuSearchList
      } else {
        wordsList = this.state.siuSearchList
      }
    }
    // console.log('wordsList',wordsList)
    let emptyList = this.state.search.length >= 1 && this.state.wordsList.length === 0 && this.state.activeTabIndex !== 3;
    let categoryMargin = '4px'
    // let ranDem = this.state.randomSentences[this.state.randomSentenceIndex]
    // wordsList.map((k)=>{
    //   console.log(k)
    //   k = fuzzysort.highlight(k[0], '<b>', '</b>')
    //   console.log(k)
    // })



		return (
			<div className="app" style={{fontFamily:customFontFam}}>
      <Grid textAlign='center'>
      <Grid.Row>
        <Grid.Column style={{ maxWidth: 860, padding: 0 }} textAlign='left'>
          <Link to={{pathname: "/", state: { history:this.state.history }}} >
            <Button basic style={{paddingLeft:'10px',paddingRight:'15px',marginLeft:'3px'}} icon='left chevron' content='Back to Language Resources' />
          </Link>
          <Button basic style={{float:'right',paddingLeft:'13px',paddingRight:'15px'}} onClick={() => {navigator.clipboard.writeText(WEB_URL+'?p=search'); this.setState({copyClicked:true})}} content={this.state.copyClicked ? 'Copied!' : 'Share Link'} icon='linkify' />
          {true ?
            <div style={{padding:10, paddingTop: 30,paddingBottom:0}}>
              <div style={{fontWeight:'bold',justifyContent:'left',fontSize:'21px'}}>
                {'Kiŋikmiutun Table'}
              </div>
              <div style={{fontStyle:'italic',marginTop:'25px',fontSize:'16px',color:"#707070"}}>This table is a living document written using Richard Atuk’s phonetic system for the Kiŋikmiut dialect. This table is a group effort and we hold weekly Zoom meetings where edits are often made. This is a work in progress, so please be aware there may be typos or edits needed. With permission you can edit the table <a style={{color:'#306190'}} href={"https://docs.google.com/spreadsheets/d/1Ix5QgjA94AL8L2EdRZss3Jg_YSWnO0ebsHK9DRtKAIg/edit?usp=sharing"} target="_blank">{'here'}</a>.</div>
            </div>
            :
            null
          }
        </Grid.Column>
      </Grid.Row>

      <Grid.Row style={{paddingTop:10}}>
      <Grid.Column style={{ maxWidth: 860, padding: 10 }} textAlign='left'>


					<Grid stackable>


			{this.state.homeMode === 0 ? 
					<Grid.Row>
              <Grid.Column style={{ flex: 1, paddingTop:0 }}>
					<div className='header-text'>
          	<Input
              ref={this.handleRef}
              placeholder='Search a phrase...'
              icon={this.state.search.length > 0 ? <Icon name='x' color='grey' onClick={()=>{this.setState({search:'',wordsList:[]})}} link /> : null}
              size='huge'
              onChange={this.onChangeSearch.bind(this,false,0)}
              spellcheck="false"
              value={this.state.search}
              fluid>
            </Input> 
					</div>

				  <div style={{textAlign:'center',marginTop:'5px',marginBottom:'8px'}}>
            {this.buttonGroupKeyboard(0)}

            <div style={{color:'#5c5c5c',marginTop:'10px', marginBottom:'20px'}}>
              <span>
                <div style={{fontSize:'16px',marginBottom:'20px',color:'#5c5c5c',fontWeight:'300'}}>          
                <span>{'Show: '}</span><Dropdown inline scrolling style={{border:'solid 1px #22242626',padding:'5px 6px',borderRadius:'5px',marginRight:'10px'}} value={this.state.showOptionValue} onChange={this.showSiuList.bind(this)} options={showOptions} />
                <span>{'Sort by: '}</span>{this.state.search.length > 0 ? <Dropdown inline scrolling disabled text={'Search Matches'} style={{border:'solid 1px #22242626',padding:'5px 6px',borderRadius:'5px',marginRight:'4px'}} /> : <Dropdown inline scrolling style={{border:'solid 1px #22242626',padding:'5px 6px',borderRadius:'5px',marginRight:'4px'}} value={this.state.sortOptionValue} onChange={this.sortSiuList.bind(this)} options={sortOptions} />}
                </div>
              </span>
            </div>

				  </div>


            <Grid style={{padding:"0px 0px"}}>
              <Grid.Row style={{border:"1px solid rgb(227, 227, 227)", backgroundColor:'#f2f2f2',fontSize:'16px',fontStyle:'italic',marginTop:'10px',padding:'10px 0px',fontWeight:'500'}} columns={8}>
                <Grid.Column width={this.state.largeWindow ? 1:2}>
                  {this.returnNonLinguisticTerm('ID','bottom')}
                </Grid.Column>
                <Grid.Column width={this.state.largeWindow ? 3:6}>
                  {this.returnNonLinguisticTerm('Kiŋikmiut','bottom')}
                </Grid.Column>
                <Grid.Column width={this.state.largeWindow ? 3:6}>
                  {this.returnNonLinguisticTerm('English','bottom')}
                </Grid.Column>
                {this.state.largeWindow? 
                <Grid.Column width={2}>
                  {this.returnNonLinguisticTerm('Qawiaraq','bottom')}
                </Grid.Column>
                  :
                  null
                }
                {this.state.largeWindow? 
                <Grid.Column width={2}>
                  {this.returnNonLinguisticTerm('Qikiqtaġruk','bottom')}
                </Grid.Column>
                  :
                  null
                }
                {this.state.largeWindow? 
                <Grid.Column width={2}>
                  {this.returnNonLinguisticTerm('Utqiaġvik','bottom')}
                </Grid.Column>
                  :
                  null
                }
                {this.state.largeWindow? 
                <Grid.Column width={2}>
                  {this.returnNonLinguisticTerm('Qigiqtaq','bottom')}
                </Grid.Column>
                  :
                  null
                }
                <Grid.Column width={this.state.largeWindow ? 1:2}>
                </Grid.Column>
              </Grid.Row>
            </Grid>

					</Grid.Column>
				</Grid.Row>
				:
				null
			}
				</Grid>



          {emptyList ? 
            <div style={{marginTop:35,textAlign:'center',fontSize:'16px'}}>
              {'No matches...'}
              {this.state.showOptionValue != 1 ?
                <div>
                  <div>{'You are searching within "'+englishShowOptions[this.state.showOptionValue]+' Terms" only.'}</div>
                  <div style={{cursor:'pointer',color:'#306190'}} onClick={()=>{this.setState({showOptionValue:1,siuSearchList:[...this.props.siuSearchList]},()=>{this.showSiuList()})}}>{'Click here to search within all terms.'}</div>
                </div>
                :
                null
              }
            </div>
            : 

          (this.state.search < 1 ?

            <List divided>
              {wordsList.map((word) => 
                {
                  return this.returnListItem(word, -1)
                })}
          </List>

          :

            <List divided>

              	{wordsList.map((word) => 
						    {
                  let strongestHit = -100000000;
                  let bestHitIndex = -1;
                  let bestHitStartIndex = -1
                  let arraySize = 6
                  // if (!this.state.largeWindow) {
                  //   arraySize = 2
                  // }
                  Array.from(Array(arraySize).keys()).reverse().map((i)=>{
                    if (word[i] !== null && word[i]._score > strongestHit) {
                      strongestHit = word[i].score
                      bestHitIndex = i
                      bestHitStartIndex = Math.floor(i/2)
                    }
                  })

                return this.returnListItem(word, bestHitIndex)

						    })}
          </List>
        )
        }


          <List>

        

      	<div>



{/*
          {!displayList && this.state.homeMode === 0 && !emptyList ? 
            <div style={{display:'flex',justifyContent:'center',padding:'30px 0px'}}>
              <div style={{fontSize:'1.2rem',color:'#666',lineHeight:1.6,maxWidth:500}}>
                <div>
                <div style={{marginBottom:10}}> Type any English or Inupiaq phrase and matching entries will show automatically.</div>
                <div> Examples: </div>
                <div>
                <span onClick={()=>{this.setState({search:"yak'éi",wordsList: fuzzysort.go("yak'éi", this.props.dictionarySearchList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>yak'éi</span>
                <span>{', '}</span>
                <span onClick={()=>{this.setState({search:'Gunalchéesh',wordsList: fuzzysort.go('Gunalchéesh', this.props.dictionarySearchList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>Gunalchéesh</span>
                <span>{', '}</span>
                <span onClick={()=>{this.setState({search:'x̲áat',wordsList: fuzzysort.go('x̲áat', this.props.dictionarySearchList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>x̲áat</span>
                <span>{', '}</span>
                <span onClick={()=>{this.setState({search:'book',wordsList: fuzzysort.go('book', this.props.dictionarySearchList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>book</span>
                <span>{', '}</span>
                <span onClick={()=>{this.setState({search:'blanket',wordsList: fuzzysort.go('blanket', this.props.dictionarySearchList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>blanket</span>         
                <span>{', '}</span>
                <span onClick={()=>{this.setState({search:'she sees it',wordsList: fuzzysort.go('she sees it', this.props.dictionarySearchList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>she sees it</span>        
                </div>
                </div>


              </div>
            </div>
            :
            null
          }*/}


        </div>

            </List>






        </Grid.Column>
        </Grid.Row>
      </Grid>


			</div>
		);
	}
}
export default Home;